import { Injectable } from '@angular/core';
import { CoreActions, CoreSelectors, SuperStore } from '@bilancio/root-store';

@Injectable({
    providedIn: 'root'
})
export class ChangeOfficeService {
    offices$ = this.store.select(CoreSelectors.getOffices);
    currentOffice$ = this.store.select(CoreSelectors.getCurrentOffice);

    constructor(private readonly store: SuperStore) {}

    selectCurrentOffice(officeId: number) {
        this.store.dispatch(CoreActions.selectCurrentOffice({ officeId }));
    }
}
